// modules
import { createAction } from 'redux-actions'

export const setCompanyDiseases = createAction('COMPANY_DISEASES_SET')
